module.exports = "https://static.zego.com/_next/static/images/icon-tick-mask-78929ba5507448bc8c1792779cf13d3c.svg";